//  For each product on the page
(function () {
    // save the section id from the script tag and find the section
    const sectionID = document.currentScript.dataset.id;
    const section = document.querySelector(`#${sectionID}`);

    // exit if section is not found
    if (!section) {
        console.warn(`Product section with ID ${sectionID} not found.`);
        return;
    }


    const product = JSON.parse(section.querySelector(".productV15JSON").textContent);
    const variantIDtoColor = JSON.parse(section.querySelector(".productV15VariantIDtoColor").textContent);
    let activeVariant = JSON.parse(section.querySelector(".activeVariantJSON").textContent);
    const subscriptionAppID = section.querySelector(".productV15SubscriptionAppID").textContent;
    let quantity = 1;

    const hasSticky = !!section.querySelector(".productV15Sticky");

    // during dev mode, set the active variant to the window so it can be accessed in the console
    if (Shopify.theme.role === "development") {
        window.product = product;
        window.activeVariant = activeVariant;
    }

    // function to return the selling_plan_id given a variant ID
    function getSellingPlanID(product, activeVariant) {
        // create an array of selling plans that are accessible for the variant
        const validSellingPlans = [];

        // loop over each group
        for (const group of product.selling_plan_groups) {
            // if the group doesn't match our subscription app ID, skip it
            if (group.app_id !== subscriptionAppID) {
                continue
            }

            // loop through each selling plan in the group
            for (const plan of group.selling_plans) {
                // add the plan ID to the validSellingPlans array
                validSellingPlans.push(plan.id);
            }
        }

        // loop through selling plan allocations of the variant and find the first one that matches a valid selling plan
        for (const allocation of activeVariant.selling_plan_allocations) {
            if (validSellingPlans.includes(allocation.selling_plan_id)) {
                return allocation.selling_plan_id;
            }
        }

        // if no valid selling plan is found, return null
        return null;
    }


    /************
     Product Swipers
     ************/

        // hydrate each wrap's swipers only the first time it becomes visible
    const initializedWraps = new WeakSet();

    function ensureSwipers(element) {
        if (!element || initializedWraps.has(element)) {
            return;
        }
        initializedWraps.add(element);

        const thumbsSwiper = new Swiper(element.querySelector(".productV15VisualThumbs"), {
            slidesPerView: 6,
            spaceBetween: 10,
            loop: true,
            breakpoints: {
                800: {
                    slidesPerView: 6,
                    spaceBetween: 23
                }
            }
        });

        new Swiper(element.querySelector(".productV15VisualSwiper"), {
            slidesPerView: 1,
            spaceBetween: 6,
            loop: true,
            navigation: {
                nextEl: element.querySelector(".productV15VisualSwiperNext"),
                prevEl: element.querySelector(".productV15VisualSwiperPrev"),
            },
            breakpoints: {
                800: {
                    spaceBetween: 23
                }
            },
            thumbs: {
                swiper: thumbsSwiper
            },
            autoHeight: true,
        });
    }

    // only init swipers for the wrap(s) already marked active by liquid
    section.querySelectorAll(".productV15VisualWrap.active").forEach(ensureSwipers);
    // Quotes swiper
    new Swiper(section.querySelector(".productV15Quotes"), {
        slidesPerView: 1,
        spaceBetween: 16,
        loop: true,
        speed: 4000,
        autoplay: {
            delay: 5000,
            disableOnInteraction: false
        }
    });

    // change slide on thumbnail click
    section.querySelectorAll(".productV15VisualThumbsSlide").forEach(element => {
        element.addEventListener("click", function () {
            // change slide
            productSwiper.slideTo(this.dataset.index - 1);
        });
    });


    // update active variant on input changes
    section.querySelectorAll("input, select").forEach(function (element) {
        element.addEventListener("change", function () {

            updateProduct();
        });
    })


    /**************
     Update Product
     ***************/

    function isSubscription() {
        return !!document.querySelector(`.productV15SubLabelInput[value="sub"]:checked`);
    }

    async function updateProduct() {
        // Find the active variant
        if (product.variants.length === 1) {
            // default fallback
            activeVariant = product.variants[0];
        } else {
            // collect options from inputs
            let options = [];
            section.querySelectorAll(`.productV15FormOptionsItem`).forEach(group => {
                options.push(group.querySelector(`input:checked`).value);
            });


            // find new variant based on the options
            activeVariant = product.variants.find((variant) => {
                return JSON.stringify(variant.options) === JSON.stringify(options)
            });
        }

        // check if variant wasn't found
        if (!activeVariant) {
            section.querySelectorAll('.productV15ATC').forEach(btn => {
                btn.disabled = true;
            })
            section.querySelector(".productV15ATCText").textContent = "Not Available";

            return;
        }

        // delivery frequency
        section.querySelectorAll(".productV15SubLabelBodyBulletsItemTxt .frequency")?.forEach((item) => {
            item.textContent = "";
        })

        // flavor choice
        section.querySelectorAll('.productV15FormOptionsItemLabelChoice')?.forEach((item) => {
            item.textContent = activeVariant.options[0];
            item.style.color = variantIDtoColor[activeVariant.id];
        })


        /**************
         Price
         ***************/

        let sellingPlanExists = document.querySelector('.productV15SubLabel') || false;

        let sellingPlanID = null;
        let sellingPlan = null;


        // if there's a subscription we need to update both prices
        if (sellingPlanExists) {
            // Select both sets of elements at once
            const compares = section.querySelectorAll(".productV15SubLabelBodyHeaderPriceCompare");
            const reals = section.querySelectorAll(".productV15SubLabelBodyHeaderPriceReal");

            // reset compare
            compares.forEach(item => {
                item.textContent = "";
            });

            // Destructure them for clarity:
            // Assuming the markup is structured so that index 0 is for subscription, index 1 for one-time purchase
            const [subCompare, oneTimeCompare] = compares;
            const [subReal, oneTimeReal] = reals;


            // find the allocation that matches the selling plan ID
            sellingPlanID = getSellingPlanID(product, activeVariant);
            if (sellingPlanID) {
                // find the allocation so we can determine price for this variant
                let allocation = activeVariant.selling_plan_allocations.find(allocation => allocation.selling_plan_id === sellingPlanID);

                // find the selling plan by ID to determine the frequency
                sellingPlan = product.selling_plan_groups.flatMap(group => group.selling_plans).find(plan => plan.id === sellingPlanID);

                const allocationPrice = allocation.price;

                // Update subscription prices
                if (activeVariant.price > allocationPrice) {
                    subCompare.textContent = price(activeVariant.price, true);
                }
                subReal.textContent = price(allocationPrice * discountMultiplier, true);

                // Update one-time purchase prices
                if (activeVariant.compare_at_price > activeVariant.price) {
                    oneTimeCompare.textContent = price(activeVariant.compare_at_price * discountMultiplier, true);
                }
                oneTimeReal.textContent = price(activeVariant.price * discountMultiplier, true);


                // delivery frequency
                section.querySelectorAll(".productV15SubLabelBodyBulletsItemTxt .frequency")?.forEach((item) => {
                    item.textContent = sellingPlan.name;
                })
            }
        }

        // update swiper
        let hasDefaultSwiper = document.querySelector('.productV15VisualWrap.default') || false;
        if (hasDefaultSwiper) {

        } else {

            let variant = activeVariant;
          
            section.querySelector('.productV15VisualWrap.active')?.classList.remove('active');
            const gallerySelector = isSubscription() ? 'sub' : 'once';
            const newActiveWrap = section.querySelector(`.productV15VisualWrap.${gallerySelector}[data-id='${variant.id}']`);
            if (newActiveWrap) {
                newActiveWrap.classList.add('active');
                ensureSwipers(newActiveWrap);
            }
        }

        // shipping text
        document.querySelectorAll('.productV15IconsItem')?.forEach(item => {
            // if there is a .productIconsItemTxt.sub, check if we're subscribed
            if (item.querySelector('.productV15IconsItemTxt.sub')) {
                if (isSubscription()) {
                    item.querySelector('.productV15IconsItemTxt.sub').classList.add('active');
                    item.querySelector('.productV15IconsItemTxt.once').classList.remove('active');
                } else {
                    item.querySelector('.productV15IconsItemTxt.sub').classList.remove('active');
                    item.querySelector('.productV15IconsItemTxt.once').classList.add('active');

                }
            }
        })


        // update price
        sellingPlanID = getSellingPlanID(product, activeVariant);
        let allocation = activeVariant.selling_plan_allocations.find(allocation => allocation.selling_plan_id === sellingPlanID);

        let totalPrice = activeVariant.price;
        // if selling plan selected, use the allocation price instead
        if (isSubscription()) {
            totalPrice = allocation ? allocation.price : activeVariant.price;
        }

        section.querySelector('.productV15ATCPrice').textContent = price(totalPrice * discountMultiplier, true);

        /**************
         ATC Enable/Disable
         ***************/

        // selling plan check
        if (sellingPlanExists && !sellingPlan && isSubscription()) {
            section.querySelectorAll('.productV15ATC').forEach(btn => {
                btn.disabled = true;
            })
            section.querySelector(".productV15ATCText").textContent = "Subscription Unavailable";

        }

        // check if the variant is in stock
        else if (activeVariant.available) {
            section.querySelectorAll('.productV15ATC').forEach(btn => {
                btn.disabled = false;
            })
            section.querySelector(".productV15ATCText").textContent = "Add To Cart";

        } else {
            section.querySelectorAll('.productV15ATC').forEach(btn => {
                btn.disabled = true;
            })
            section.querySelector(".productV15ATCText").textContent = "Sold Out";
            section.querySelector(".productV15ATCText").textContent = "Sold Out";

        }


        // update url with variant id so the selected options are maintained on refresh
        let url = new URL(window.location.href);
        url.searchParams.set("variant", activeVariant.id);
        window.history.replaceState({}, "", url);
    }

    // on load, update the product
    // this accomplishes loading the correct variant image and price on page load
    updateProduct();

    /**************
     Delivery time
     ***************/
    let deliveryExists = section.querySelector(".productV15Shipping") || false;
    if (deliveryExists) {
        // get cutoff time (0-24 hour)
        let cutoff = parseInt(section.querySelector(".productV15Shipping").dataset.cutoff);
        // get current time
        let now = new Date();
        let hours = now.getHours();
        let minutes = now.getMinutes();
        let seconds = now.getSeconds();

        // get time until next cutoff
        let timeUntilCutoff = (cutoff - hours) * 60 * 60 - (minutes * 60 + seconds);
        if (timeUntilCutoff < 0) {
            timeUntilCutoff += 24 * 60 * 60;
        }
        // convert to hours, minutes, seconds
        let hoursUntilCutoff = Math.floor(timeUntilCutoff / 3600);
        let minutesUntilCutoff = Math.floor((timeUntilCutoff % 3600) / 60);

        // update text (x hrs x mins)
        section.querySelector('.productV15ShippingOrderCutoff').textContent = `${hoursUntilCutoff} hrs ${minutesUntilCutoff} mins`;

        // update text every second
        setInterval(() => {
            // get current time
            now = new Date();
            hours = now.getHours();
            minutes = now.getMinutes();
            seconds = now.getSeconds();

            // get time until next cutoff
            timeUntilCutoff = (cutoff - hours) * 60 * 60 - (minutes * 60 + seconds);
            if (timeUntilCutoff < 0) {
                timeUntilCutoff += 24 * 60 * 60;
            }
            // convert to hours, minutes, seconds
            hoursUntilCutoff = Math.floor(timeUntilCutoff / 3600);
            minutesUntilCutoff = Math.floor((timeUntilCutoff % 3600) / 60);

            // update text (x hrs x mins)
            section.querySelector('.productV15ShippingOrderCutoff').textContent = `${hoursUntilCutoff} hrs ${minutesUntilCutoff} mins`;

        }, 1000);
    }


    /**************
     Product ATC
     ***************/

    section.querySelectorAll('.productV15ATC').forEach(btn => {
        btn.addEventListener("click", async function () {

            // add loading animation to both buttons
            section.querySelector(".productV15ATC").classList.add("loading");
            if (hasSticky) section.querySelector(".productV15StickyATC").classList.add("loading");


            let formData = {
                items: [{
                    quantity: quantity,
                    id: activeVariant.id,
                }]
            };

            // check for discount kit value
            if (section.querySelector(".productV15ATC").dataset.discountKit) {
                formData.items[0].properties = {
                    _discount_kit: section.querySelector(".productV15ATC").dataset.discountKit
                }
            }

            // check for selling plan
            if (isSubscription()) {
                formData.items[0].selling_plan = getSellingPlanID(product, activeVariant);
            }

            // add product
            await addProduct(formData);

            // remove loading animation
            section.querySelector(".productV15ATC").classList.remove("loading");
            if (hasSticky) section.querySelector(".productV15StickyATC").classList.remove("loading");
        });
    })


    document.querySelectorAll(`a[href="#product"]`)?.forEach(link => {
        link.addEventListener("click", (e) => {
            e.preventDefault();
            section.scrollIntoView({behavior: "smooth"});
        })
    })

})();
